import { render, staticRenderFns } from "./chat-solicitacao-comentario.vue?vue&type=template&id=526399ee&scoped=true"
import script from "./chat-solicitacao-comentario.ts?vue&type=script&lang=ts&external"
export * from "./chat-solicitacao-comentario.ts?vue&type=script&lang=ts&external"
import style0 from "./chat-solicitacao-comentario.scss?vue&type=style&index=0&id=526399ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526399ee",
  null
  
)

export default component.exports